import {GenericArrayEntityService, GenericArrayEntityServiceImpl, GenericItem} from "./GenericArrayEntityService";
import {injectable} from "inversify";

export const MASS_UPDATE_SERVICE_NAME = "MassUpdateService";

export interface MassUpdateItem extends GenericItem {
    status: string,
    userId: string,
    currencyCode: string,
    amount: string,
    comment: string,
    walletAccountType?: string,
    pokUserId?: string,
    errorMessage?: string
}

export interface MassUpdateService extends GenericArrayEntityService<MassUpdateItem> {

}

@injectable()
export class MassUpdateServiceImp extends GenericArrayEntityServiceImpl<MassUpdateItem> {
}


// WEBPACK FOOTER //
// ./src/app/service/admin/MassUpdateService.ts